export enum BillingModel {
  FEE_FOR_LIFE = 'feeForLife',
  FEE_FOR_SERVICE = 'feeForService',
}
